import * as React from 'react';
import { EducationEntryType } from '../../../Types/EducationType';
import { EducationItemLayout, Props as EducationItemProps } from '../Layouts/EducationItemLayout';

export type Props = {
	lines: Array<EducationEntryType>;
};

export const generateEducationItem = (props: Props) => {
	const returnValue = props.lines.map((line: EducationEntryType, index: number) => {
		const educationItemProps: EducationItemProps = {
			entry: line,
		};
		const innerReturnValue = <EducationItemLayout key={'educationItem_' + index} {...educationItemProps} />;
		return innerReturnValue;
	});
	return returnValue;
};
